export const CRM_SEARCH_URL = '/crm-search/search/';
export const FETCH_GOAL_TARGETS_OVERRIDE_PERMISSION_URL = '/performance/v1/goals/search/override-permissions';
export const FETCH_ALL_CAMPAIGN_PERFORMANCE = '/performance/v1/goals/report-proxy/filtered-ad-campaigns';
const GOAL_PERFORMANCE_BASE_URL = '/performance/v1/goals/';
export const GOAL_EDIT_PERMISSION_URL = `${GOAL_PERFORMANCE_BASE_URL}permissions/editable-targets`;